import type { FaireProductEntity } from "../../entity_types/product";

export const p_a3c8qcnw56: FaireProductEntity = {
  token: "p_a3c8qcnw56",
  type: "product",
  name: "Cactus Costume for Adults",
  brandToken: "b_2rys9jdptm",
  brandName: "Toynk",
  imageUrl:
    "https://cdn.faire.com/fastly/ffa826be583be02893d253f3fa40a2eb3ffdb997118af5d61b9373de8137d3cb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0b1ba6a7f20186e6e76d7d11e9bdd12c8e2e1e9725620aa81960383cf2aedb74.jpeg",
    "https://cdn.faire.com/fastly/58247de65eb413ee3ed4b3b05c2a86581d9207a28207a8a7dd1000e339e8f6d3.jpeg",
  ],
  priceDollars: 34.64,
  description:
    'Bring the heat with a plant-tastic costume\n\nLook sharp in this cactus costume! Designed to look like a saguaro cactus, this cute adult costume is finely detailed with a full-body green suit that serves as the trunk of the unique desert plant. This funny costume includes a one-piece tunic, along with soft white "spikes" and matching white flowers on the head of the piece. Made of 100% polyester tricot laminated with foam, this high-quality cactus costume is perfect for attending themed parties and cosplay events year-round.',
  tags: [],
  msrpDollars: 69.27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:12.087Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
